import { render, staticRenderFns } from "./PermissionManageModal.vue?vue&type=template&id=10522427&"
import script from "./PermissionManageModal.vue?vue&type=script&lang=js&"
export * from "./PermissionManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports